import { LabelType } from '@/types/gql.generated';
import { Box } from '@/ui';
import { SectionHeader } from '../SectionHeader';
import { ColorCategoriesSection } from './ColorCategoriesSection';
import { LabelTagsSection } from './LabelTagsSection';

export const CategoriesSection = () => {
  return (
    <Box maxW="700px">
      <SectionHeader
        description="Set up the colors and labels you use across this schedule once — they will be ready on every event and every view. You can still add or rename them inside any event."
        title="Categories & labels"
      />

      <ColorCategoriesSection />

      <LabelTagsSection
        description="People or groups an event is for."
        labelType={LabelType.Who}
        placeholder="Add a person or group…"
        title="Who"
        variant="who"
      />

      <LabelTagsSection
        description="Topics or activity types — practice, performance, fundraiser, and so on."
        labelType={LabelType.Default}
        placeholder="Add a topic…"
        title="What"
        variant="what"
      />
    </Box>
  );
};
